module.exports = __webpack_public_path__ + "img/ke.af8f4174.svg";